var _circle, _path, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHappy = function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 232,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 384c-45.4 0-83.6-29.5-95.7-69.8-1.2-4.3 1.3-8.7 5.5-9.9.7-.2 1.5-.3 2.3-.3h175.7c4.4-.1 8.1 3.5 8.1 7.9 0 .8-.1 1.5-.3 2.3-11.9 40.3-50.1 69.8-95.6 69.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 232,
    r: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 48v16c26.6 0 51.8 5.4 74.7 15.1 34.4 14.6 63.8 38.9 84.5 69.6C435.9 179.3 448 216.2 448 256c0 26.6-5.4 51.8-15.1 74.7-14.6 34.4-38.9 63.8-69.6 84.5C332.7 435.9 295.8 448 256 448c-26.6 0-51.8-5.4-74.7-15.1-34.4-14.6-63.8-38.9-84.5-69.6C76.1 332.7 64 295.8 64 256c0-26.6 5.4-51.8 15.1-74.7 14.6-34.4 38.9-63.8 69.6-84.5C179.3 76.1 216.2 64 256 64V32c-30.9 0-60.4 6.3-87.2 17.6-40.2 17-74.4 45.4-98.5 81.1C46.1 166.5 32 209.7 32 256c0 30.9 6.3 60.4 17.6 87.2 17 40.2 45.4 74.4 81.1 98.5 35.8 24.2 79 38.3 125.3 38.3 30.9 0 60.4-6.3 87.2-17.6 40.2-17 74.4-45.4 98.5-81.1 24.2-35.8 38.3-79 38.3-125.3 0-30.9-6.3-60.4-17.6-87.2-17-40.2-45.4-74.4-81.1-98.5C345.5 46.1 302.3 32 256 32v16z"
  })));
};

export default SvgHappy;